/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Keeping a VBA project in a macro-enabled file does not make its buttons, events or automation run in GridCraft. Use a supported Excel desktop workflow when execution of existing VBA is required.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不能。将 VBA 项目保存在宏启用文件中，并不意味着 GridCraft 可以运行它的按钮、事件或自动化流程。需要执行现有 VBA 时，应使用支持该功能的 Excel 桌面环境。`)
};

/**
* | output |
* | --- |
* | "No. Keeping a VBA project in a macro-enabled file does not make its buttons, events or automation run in GridCraft. Use a supported Excel desktop workflow wh..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_0_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_0_answer as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.0.answer" }